var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoZimtapp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a5eaf74a-69c3-4ab2-9ac5-ade44b2a9511",
    "data-name": "acb10348-53da-46b0-8327-5e5cfb3103e9",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ae1c687c-a0e2-4268-b1fa-51e25ac61f1e",
    x1: 35.93,
    y1: 16.03,
    x2: 22.34,
    y2: 0.5,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 49.89)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d8d4d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6a5e5a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b2048aee-82df-4bb3-a978-71b4b320b74e",
    x1: 25.55,
    y1: 23.26,
    x2: 37.97,
    y2: 40.86,
    xlinkHref: "#ae1c687c-a0e2-4268-b1fa-51e25ac61f1e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e8f948b4-f1e3-422a-a1c0-1faf4d3a5783",
    x1: 26.56,
    y1: 39.33,
    x2: 33.36,
    y2: 46.97,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 49.89)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d8d4d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo-zimtapp") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "b919e74f-243a-4c34-bd0c-ec83c412424d",
    "data-name": "a40843e0-9032-4d27-88c0-58646a347f04"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.29,29.86,24.88,40.25a1,1,0,0,0,.4,1.28,1,1,0,0,0,.63.09l15-3Z",
    style: {
      fill: "url(#ae1c687c-a0e2-4268-b1fa-51e25ac61f1e)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "fa851921-f50a-46fb-bb2b-e8e6687575e8",
    "data-name": "f00a4fa7-199b-47ad-a84e-2d48e694bfe8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.57,32.7a1,1,0,0,1-.25-1.19h0l5.4-10.36,15-3a1,1,0,0,1,.63.09,1,1,0,0,1,.41,1.28L30.29,29.87,24.88,40.25a1,1,0,0,0,.08,1h0l-10.42-8.6,5.17-11.52,14.95-3",
    style: {
      fill: "url(#b2048aee-82df-4bb3-a978-71b4b320b74e)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "b6573470-2cb9-4eb1-814b-45bdcae9ed57",
    "data-name": "bf7d77c5-c490-4a12-9059-982f95168965"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.46,18.31,24.88,9.59a1,1,0,0,0-.79-.2l-14.95,3,10.57,8.72,14.95-3a1,1,0,0,1,.63.09l.14.09",
    style: {
      fill: "url(#e8f948b4-f1e3-422a-a1c0-1faf4d3a5783)"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoZimtapp);
export default __webpack_public_path__ + "static/media/logo-zimtapp.e3d03a179ada7665adbfb40acd14ba29.svg";
export { ForwardRef as ReactComponent };